import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component } from '@angular/core';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';

import { VirtualAgentTrainFailedNotificationModel } from '../models/virtual-agent-trained-notification-model';

@Component({
  selector: 'cai-virtual-agent-train-failed-notification',
  templateUrl: './virtual-agent-train-failed-notification.component.html',
  styleUrls: ['./virtual-agent-train-failed-notification.component.scss'],
  standalone: false,
})
@NotificationType('VirtualAgentTrainFailedNotification')
export class VirtualAgentTrainFailedNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    this.notification = JSON.parse(data.payload);
  }

  notification: VirtualAgentTrainFailedNotificationModel;

  constructor(
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
  ) {}

  showNotification(notification: NotificationModel) {
    this.notification = JSON.parse(notification.payload);

    const message = this.localizationService.instant(
      'Project::VirtualAgentTrainingFailed',
      this.notification.name,
    );

    this.toasterService.error(message);
  }
}
